<template>
  <div class="login-page-wrapper d-flex flex-column justify-content-center align-items-center">

    <div class="text-center mb-4 logo-area">
      <div class="d-flex align-items-center justify-content-center">
        <i class="bx bx-atom" style="font-size: 3rem; color: #0056b3; margin-right: 10px;"></i>
        <h2 class="m-0" style="color: #0056b3; font-weight: bold;">НИЯУ МИФИ</h2>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-5">
          <div class="card card-login p-4">
            <div class="card-body">
              <h4 class="text-center mb-4 card-title">
                Доступ к информационным системам НИЯУ МИФИ
              </h4>

              <div v-if="errorMessage" class="alert alert-danger text-center" role="alert" style="font-size: 0.9rem;">
                {{ errorMessage }}
              </div>

              <form @submit.prevent="handleLogin">

                <div class="form-group mb-3">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="bx bx-user"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Имя пользователя"
                      type="text"
                      v-model="username"
                      :disabled="loading"
                      required>
                  </div>
                </div>

                <div class="form-group mb-4">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="bx bx-lock-alt"></i>
                      </span>
                    </div>

                    <input
                      class="form-control"
                      placeholder="Пароль"
                      :type="passwordVisible ? 'text' : 'password'"
                      v-model="password"
                      :disabled="loading"
                      required>

                    <div class="input-group-append" @click="passwordVisible = !passwordVisible">
                      <span class="input-group-text toggle-password">
                        <i v-if="passwordVisible" class="bx bx-hide" style="font-size: 1.2rem;"></i>
                        <i v-else class="bx bx-show" style="font-size: 1.2rem;"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-4">
                  <button type="submit" class="btn btn-primary px-4" :disabled="loading">
                    <span v-if="loading">Вход...</span>
                    <span v-else>Войти</span>
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../server';

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      errorMessage: null,
      passwordVisible: false
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.errorMessage = null;

      try {
        const formData = new FormData();
        formData.append('Username', this.username);
        formData.append('Password', this.password);

        const response = await axios.post(`${API_URL}/api/auth/login`, formData, {
          headers: {
            'accept': '*/*',
          }
        });

        console.log('Login successful:', response.data.data.token);

        const token = response.data.data.token || response.data;

        if (token) {
          localStorage.setItem('token', token);
          this.$router.push('/');
        } else {
          this.$router.push('/');
        }

      } catch (error) {
        console.error('Login error:', error);

        if (error.response) {
          if (error.response.status === 401 || error.response.status === 400) {
            this.errorMessage = 'Неверное имя пользователя или пароль';
          } else {
            this.errorMessage = `Ошибка сервера: ${error.response.status}`;
          }
        } else if (error.request) {
          this.errorMessage = 'Нет ответа от сервера. Проверьте соединение.';
        } else {
          this.errorMessage = 'Произошла ошибка при отправке запроса.';
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page-wrapper {
  min-height: 100vh;
  background-color: #f1f3f6;
  padding: 20px;
}

.card-login {
  border: none;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border-radius: 4px;
}

.card-title {
  color: #555;
  font-weight: 400;
  line-height: 1.4;
}

// Styling Bootstrap input groups
.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: none;
  background-color: white;
  border-radius: 0.25rem;

  .form-control {
    box-shadow: none;
    border: none;
    padding-left: 10px;
    &:focus {
      background-color: white;
    }
  }

  // LEFT ICON (User/Lock)
  .input-group-prepend .input-group-text {
    background-color: white;
    border: none;
    color: #adb5bd;
    padding-right: 0;

    // Ensure Boxicons are vertically aligned
    i {
      font-size: 1.2rem;
      line-height: 1;
    }
  }

  // RIGHT ICON (Eye)
  .input-group-append {
    cursor: pointer;
    .input-group-text {
      background-color: white;
      border: none;
      padding-left: 5px;
      padding-right: 15px;
      color: #333; // Darker color for the eye

      display: flex;
      align-items: center;

      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.btn-primary {
  background-color: #1d5d9b;
  border-color: #1d5d9b;
  border-radius: 2px;
  font-weight: 600;
  &:hover {
    background-color: #154a7d;
  }
  &:disabled {
    background-color: #a0bace;
    border-color: #a0bace;
    cursor: not-allowed;
  }
}
</style>
